// Add-ons behave like cart items. Every "add to cart" link and every in-cart
// stepper/remove control carries data-cart-op + data-add-on-product-id; a single
// delegated listener posts the change and swaps in the re-rendered cart, so the
// buttons keep working after the swap replaces them.

const ENDPOINT = '/cart/add_ons';

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

function swapCart(html) {
  document.querySelectorAll('[data-cart-container]').forEach((el) => {
    el.innerHTML = html;
  });
}

function showCartError(message) {
  // The error element lives inside the freshly-swapped cart, so set it after.
  document.querySelectorAll('[data-cart-error]').forEach((el) => {
    el.textContent = message;
    el.hidden = false;
  });
}

function postCartChange(op, productId, trigger) {
  if (trigger) trigger.disabled = true;

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: JSON.stringify({ add_on_product_id: productId, op: op }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (typeof data.cart_html === 'string') swapCart(data.cart_html);
      if (!data.ok && data.error) showCartError(data.error);
    })
    .catch(() => {
      showCartError('Sorry, that could not be updated. Please try again.');
    })
    .finally(() => {
      // The trigger may have been replaced by the swap; re-enabling a detached
      // node is harmless, and links outside the cart need it.
      if (trigger) trigger.disabled = false;
    });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cart-op]');
  if (!trigger) return;

  const productId = trigger.getAttribute('data-add-on-product-id');
  const op = trigger.getAttribute('data-cart-op');
  if (!productId || !op) return;

  event.preventDefault();
  postCartChange(op, productId, trigger);
});
